// import * as apiV1 from '../network/v1'
import * as apiV2 from '../network/v2'
import * as apiV1 from '../network/v1'
import * as auth from '../network/v2/auth'

export const getLatestNews = (
  { state, commit },
  { pageSize, cb = () => { }, category, load = 1 }
) => {
  apiV2.getLatestNews(
    (data, count) => {
      for (let i = 1; i <= load; i++) {
        commit("setAllnews", data.slice((i - 1) * pageSize, i * pageSize));
        commit("incrementCurrentPage");
      }
      commit("setNewsCount", count);
      cb();
    },
    state.currentPage,
    pageSize * load,
    category
  );
};

export const getUzbekistanNews = ({ commit }, { cb = () => { }, province }) => {
  apiV2.getUzbekistanNews((data) => {
    commit('setUzbekistanNews', data)
    cb()
  }, province)
}


export const getNewsDetails = ({ commit }, { slug, err }) => {
  return apiV2.getNewsDetails(
    data => {
      commit("setActiveArticle", data);
    },
    slug,
    err
  );
};

export const searchNews = ({ state, commit }, { query, cb }) => {
  apiV2.searchNews((data, count) => {
    commit('setSearchNews', data)
    commit('setSearchCount', count)
    cb()
  }, query, state.searchPage, 10)
  commit('incrementSearchPage')
}

export const getLatestRecommendations = (
  { state, commit },
  { pageSize, load = 1 }
) => {
  apiV2.getLatestRecommendations(
    (data, count) => {
      for (let i = 1; i <= load; i++) {
        commit("incrementSearchReccomendPage");
      }
      commit("setSearchReccomend", data);
      commit("setSearchReccomendCount", count);
    },
    state.searchReccomendPage,
    pageSize * load
  );
};

export const weatherCurrency = ({ commit }) => {
  apiV2.weatherCurrency(data => {
    commit("setWeatherCurrency", data);
  });
};

export const football = ({ commit }) => {
  apiV2.football(data => {
    commit("setFootball", data);
  });
};

export const population = ({ commit }) => {
  apiV2.population(data => {
    commit("setPopulation", data);
  });
};

export const movies = ({ commit }) => {
  apiV2.movies(data => {
    commit("setMovies", data);
  });
};

export const getEmployees = ({ state, commit }, { cb = () => { } }) => {
  apiV1.getEmployees(
    (data, count) => {
      commit("setEmployees", data);
      commit("setEmployeesCount", count);
      cb();
    },
    10,
    state.employeesPage
  );
  commit("incrementEmployeesPage");
};

export const getJournalists = ({ state, commit }, { cb = () => { } }) => {
  apiV1.getJournalists(
    (data, count) => {
      commit("setJournalists", data);
      commit("setJournalistsCount", count);
      cb();
    },
    10,
    state.journalistsPage
  );
  commit("incrementJournalistsPage");
};



export const getTokens = ({ commit }, { cb, credentials, err }) => {
  auth.getTokens((access, refresh) => {
    commit('setTokens', { access, refresh })
    cb()
  }, credentials, err)
}

export const verifyToken = ({ getters }, { cb, err }) => {
  auth.verifyToken(cb, getters.access, err)
}

export const refreshToken = ({ getters, commit }, { cb = () => { }, err }) => {
  auth.refreshToken((access) => {
    cb()
    commit('setAccessToken', access)
  }, getters.refresh, err)
}

export const signUp = ({ getters }, { cb, err = () => { } }) => {
  const formData = new FormData();

  for (const name in getters.userModel) {
    formData.append(name, getters.userModel[name]);
  }
  apiV1.signUp(() => {
    cb()
  }, formData, err)
}

export const getMe = ({ getters, commit }, { cb = () => { }, err = () => { } }) => {
  apiV1.getMe((data) => {
    commit('setUser', data)
    cb()
  }, getters.access, err)
}

export const getSubCategories = ({ commit }, { cb = () => { }, preferredLang }) => {
  apiV2.getSubCategories((data) => {
    commit('setSubCategories', data)
    cb(data)
  }, preferredLang)
}

export const getTags = ({ commit }, { cb = () => { }, preferredLang }) => {
  apiV2.getTags((data) => {
    commit('setTags', data)
    cb()
  }, preferredLang)
}
export const createArticle = ({ commit }, { cb = () => { }, preferredLang }) => {
  apiV2.getTags((data) => {
    commit('updateNewArticle', data)
    cb()
  }, preferredLang)
}

export const getStaffNews = ({ getters, commit }, { status, pageSize, load = 1 }) => {
  apiV1.getStaffNews((data, count) => {
    for (let i = 1; i <= load; i++) {
      commit('incrementStaffPage')
    }
    commit('setStaffNews', data)
    commit('setStaffCount', count)
  }, getters.access, status, getters.staffPage, pageSize * load)
}

export const getAdminNews = ({ getters, commit }, { pageSize, cb, ordering, search = "", filters = {} }) => {
  apiV2.getAdminNews((data, count) => {
    commit('setAdminNews', data)
    commit('setAdminCount', count)
    cb()
  }, getters.access, getters.adminPage, pageSize, ordering, search, filters)
}

export const getAuthorsList = ({ commit }, { cb = () => { } }) => {
  apiV1.getAuthors((data) => {
    commit('setAuthorsList', data)
    cb()
  })

}

// export const sendMessage = ({ commit }, payload) => {
//   api.createMessage(payload, message => {
//     commit('receiveMessage', message)
//   })
// }

// export const switchThread = ({ commit }, payload) => {
//   commit('switchThread', payload)
// }
